import React from 'react';
import { HashLink } from 'react-router-hash-link';

import Counter from './Counter';

import logoAds from './assets/webyoo/media/logo-ads.png';


export default () => (
  <div id="Screen_1">
    <div class="Screen_1_top" >
      <img src={logoAds} alt="L'affaire du siècle" class="logo" />
    </div>
    <div class="Screen_1_bottom">
      <h1 class="gp-title">
        URGENCE CLIMATIQUE :
        <br/>
        <span className="gp-title-sous">
          Les changements sont déjà visibles dans notre quotidien
        </span>
      </h1>
      <div>
        <div class="gb_action">
          <HashLink smooth to="#Screen_2" >
            <span class="button_icon">
              <i class="icon-pencil">
              </i>
            </span>
            <span class="button_label">JE TÉMOIGNE</span>
          </HashLink>
        </div>
        <Counter/>
      </div>
    </div>
  </div>
);
